import { render } from "./UserPrivacyOnly.vue?vue&type=template&id=8c88c9a6&scoped=true&ts=true"
import script from "./UserPrivacyOnly.vue?vue&type=script&lang=ts"
export * from "./UserPrivacyOnly.vue?vue&type=script&lang=ts"

import "./UserPrivacyOnly.vue?vue&type=style&index=0&id=8c88c9a6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c88c9a6"]])

export default __exports__